import { t } from 'i18next';
import { useCallback, useState } from 'react';

import { MessagingChannel } from '~hooks/useMessaging/models';
import useMuteChannel from '~hooks/useMessaging/useMuteChannel';

export default function useMuteToggle(channel: MessagingChannel) {
  const { toggleChannelMuted } = useMuteChannel();
  const [isSaving, setIsSaving] = useState(false);

  const label = channel.muted
    ? t('messaging.unmute_conversation')
    : t('messaging.mute_conversation');

  const toggleMuted = useCallback(async () => {
    setIsSaving(true);

    try {
      await toggleChannelMuted(channel);
    } catch {
      // Reported and toasted by the hook; the conversation keeps its mute state.
    } finally {
      setIsSaving(false);
    }
  }, [channel, toggleChannelMuted]);

  return { isSaving, label, toggleMuted };
}
